(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 92096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(69075);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(916);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useThemeProps.js + 2 modules
var useThemeProps = __webpack_require__(49723);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(17377);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(69222);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(15672);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Card/cardClasses.js


function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Card/Card.js


const _excluded = ["className", "raised"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};
const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(38706);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./pages/landingpage.module.scss
var landingpage_module = __webpack_require__(87781);
var landingpage_module_default = /*#__PURE__*/__webpack_require__.n(landingpage_module);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(67550);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./components/landingPage/header.module.scss
var header_module = __webpack_require__(37762);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./components/landingPage/button.module.scss
var button_module = __webpack_require__(72540);
var button_module_default = /*#__PURE__*/__webpack_require__.n(button_module);
;// CONCATENATED MODULE: ./components/landingPage/button.tsx






// TODO Replace with MD3 buttons when they come out
var Button = function(_param) /*#__PURE__*/ {
    var _className = _param.className, className = _className === void 0 ? "" : _className, children = _param.children, color = _param.color, onClick = _param.onClick, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children",
        "color",
        "onClick"
    ]);
    return (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "".concat((button_module_default()).button, " ").concat((button_module_default())["color".concat(color)], " ").concat(className),
        type: "button",
        onClick: onClick ? onClick : function() {}
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var landingPage_button = (Button);

// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./components/landingPage/header.tsx







var Header = function() {
    var router = (0,next_router.useRouter)();
    var introVideoUrl = "1ZHcj20eLPPYh043mHOOSS6sOh_-NxfOC";
    var loopingVideoUrl = "1vrB3kzXjgl_4qdetyHYQb6YG181kNiSM";
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), vidIndex = ref[0], setVidIndex = ref[1];
    var ref1 = react.useRef(null);
    (0,react.useEffect)(function() {
        if (vidIndex === 1 && ref1.current) {
            void ref1.current.play();
        }
    }, [
        ref1,
        vidIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (header_module_default()).header,
        "data-cy": "header",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (header_module_default()).videoWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        autoPlay: true,
                        muted: true,
                        className: (header_module_default()).video,
                        style: {
                            display: vidIndex === 0 ? "block" : "none"
                        },
                        onEnded: function() {
                            return setVidIndex(1);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            type: "video/mp4",
                            src: "https://drive.google.com/uc?export=download&id=".concat(introVideoUrl)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        ref: ref1,
                        muted: true,
                        loop: true,
                        preload: "auto",
                        className: (header_module_default()).video,
                        style: {
                            display: vidIndex === 1 ? "block" : "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            type: "video/mp4",
                            src: "https://drive.google.com/uc?export=download&id=".concat(loopingVideoUrl)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (header_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: (header_module_default()).title,
                        children: [
                            "TOURNAMENT CREATION DONE ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (header_module_default()).titleHighlight,
                                children: "RIGHT"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (header_module_default()).buttonWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(landingPage_button, {
                                color: "primary",
                                "data-cy": "headerCreateButton",
                                onClick: function() {
                                    return router.push("/tournament/new");
                                },
                                children: "Create Tournament"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(landingPage_button, {
                                color: "plain",
                                "data-cy": "headerJoinButton",
                                onClick: function() {
                                    return router.push("/tournaments");
                                },
                                children: "Join Tournament"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (header_module_default()).banner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (header_module_default()).bannerTitle,
                        children: "WELCOME TO ETOURNITY."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (header_module_default()).bannerDescription,
                        children: "Esports Tournaments - Easy & Open Source"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var header = (Header);

// EXTERNAL MODULE: ./components/landingPage/features.module.scss
var features_module = __webpack_require__(2341);
var features_module_default = /*#__PURE__*/__webpack_require__.n(features_module);
// EXTERNAL MODULE: ./components/landingPage/sectionTitle.module.scss
var sectionTitle_module = __webpack_require__(19297);
var sectionTitle_module_default = /*#__PURE__*/__webpack_require__.n(sectionTitle_module);
;// CONCATENATED MODULE: ./utils/useOnScreen.ts


function useOnScreen(ref) {
    var _$ref = (0,react.useState)(false), isIntersecting = _$ref[0], setIntersecting = _$ref[1];
    var _$ref1 = (0,react.useState)(false), everShown = _$ref1[0], setEverShown = _$ref1[1];
    var observer = (0,react.useMemo)(function() {
        if ( true && "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
            return new IntersectionObserver(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
                return setIntersecting(entry.isIntersecting);
            });
        }
        return null;
    }, [
        ref
    ]);
    (0,react.useEffect)(function() {
        var currentObserver = observer;
        if (currentObserver) {
            currentObserver.observe(ref.current);
            return function() {
                return currentObserver.disconnect();
            };
        }
    }, [
        observer,
        ref
    ]);
    (0,react.useEffect)(function() {
        if (isIntersecting) {
            setEverShown(true);
        }
    }, [
        isIntersecting
    ]);
    return {
        isIntersecting: isIntersecting,
        everShown: everShown
    };
}

;// CONCATENATED MODULE: ./components/landingPage/sectionTitle.tsx





var SectionTitle = function(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, _className = param.className, className = _className === void 0 ? "" : _className;
    var ref = react.useRef(null);
    var everShown = useOnScreen(ref).everShown;
    var visibleClassName = everShown ? (sectionTitle_module_default()).visible : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: "".concat((sectionTitle_module_default()).container, " ").concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                ref: ref,
                className: "".concat((sectionTitle_module_default()).title, " ").concat(visibleClassName),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (sectionTitle_module_default()).description,
                children: description
            })
        ]
    });
};
/* harmony default export */ var sectionTitle = (SectionTitle);

// EXTERNAL MODULE: ../../node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(92096);
;// CONCATENATED MODULE: ./components/landingPage/infoCard.tsx




var InfoCard = function(param) {
    var title = param.title, description = param.description, icon = param.icon, styles = param.styles;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        className: styles.card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: styles.cardIcon,
                src: "assets/landingpage/".concat(icon),
                alt: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: styles.cardText,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: styles.cardTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: styles.cardDescription,
                        children: description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var infoCard = (InfoCard);

;// CONCATENATED MODULE: ./components/landingPage/features.tsx







var Features = function() {
    var ref = react.useRef(null);
    var everShown = useOnScreen(ref).everShown;
    var visibleClassName = everShown ? (features_module_default()).visible : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (features_module_default()).features,
        "data-cy": "features",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionTitle, {
                title: "All you need in one place",
                description: "Take control of your tournament creation with these tools."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                ref: ref,
                className: "".concat((features_module_default()).bottom, " ").concat(visibleClassName),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(infoCard, {
                        title: "Beginner Friendly",
                        description: "Players are taken through your event step-by-step, great for beginners!",
                        icon: "\uD83D\uDE03.svg",
                        styles: (features_module_default())
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(infoCard, {
                        title: "Tournament creation in 5 Minutes",
                        description: "We make sure you get to the fun part as fast as possible.",
                        icon: "update.svg",
                        styles: (features_module_default())
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(infoCard, {
                        title: "All Settings, One Dashboard",
                        description: "Have full control over your event in a single place.",
                        icon: "tournamentController.svg",
                        styles: (features_module_default())
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(infoCard, {
                        title: "Automatic progression",
                        description: "Have a hands-off experience running the tournament.",
                        icon: "automaticProgression.svg",
                        styles: (features_module_default())
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(infoCard, {
                        title: "Unexpected Problems?",
                        description: "Solve player issues straight from your dashboard.",
                        icon: "ticketingSystem.svg",
                        styles: (features_module_default())
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var features = (Features);

// EXTERNAL MODULE: ./components/landingPage/findLobby.module.scss
var findLobby_module = __webpack_require__(9582);
var findLobby_module_default = /*#__PURE__*/__webpack_require__.n(findLobby_module);
;// CONCATENATED MODULE: ./components/landingPage/findLobby.tsx






var Img = function(param) {
    var name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: "".concat((findLobby_module_default()).image, " ").concat((findLobby_module_default())[name]),
        src: "/assets/landingpage/findLobby".concat(name, ".svg"),
        alt: name
    });
};
var FindLobby = function() {
    var ref = react.useRef(null);
    var everShown = useOnScreen(ref).everShown;
    var visibleClassName = everShown ? (findLobby_module_default()).visible : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (findLobby_module_default()).findLobby,
        "data-cy": "findLobby",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionTitle, {
                title: "Play games with the community",
                description: "Discover tournaments of other people and get to know new friends!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (findLobby_module_default()).SearchWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                        name: "SearchLg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                        name: "SearchSm"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                ref: ref,
                className: "".concat((findLobby_module_default()).bottom, " ").concat(visibleClassName),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                        name: "Filters"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (findLobby_module_default()).CardWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                                name: "Card1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                                name: "Card2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                                name: "Card3"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var findLobby = (FindLobby);

// EXTERNAL MODULE: ./components/landingPage/moreInfo.module.scss
var moreInfo_module = __webpack_require__(91857);
var moreInfo_module_default = /*#__PURE__*/__webpack_require__.n(moreInfo_module);
;// CONCATENATED MODULE: ./components/landingPage/moreInfo.tsx







var MoreInfo = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    var ref = react.useRef(null);
    var everShown = useOnScreen(ref).everShown;
    var visibleClassName = everShown ? (moreInfo_module_default()).visible : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: "".concat(className, " ").concat((moreInfo_module_default()).moreInfo),
        "data-cy": "moreInfo",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionTitle, {
                className: (moreInfo_module_default()).titleWrapper,
                title: "More of what we offer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (moreInfo_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (moreInfo_module_default()).cardWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(infoCard, {
                                title: "Streamlined Communication",
                                description: "If players run into a problem, our easy ticketing system lets them send help requests directly to your dashboard.",
                                icon: "forum.svg",
                                styles: (moreInfo_module_default())
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(infoCard, {
                                title: "Power at Your Fingertips",
                                description: "From set-up to finals, we want you to have full control over your tournament.",
                                icon: "hub.svg",
                                styles: (moreInfo_module_default())
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(infoCard, {
                                title: "Easy to Use For Players",
                                description: "From initial invitation to finals, players are being led through your event step-by-step. Great for beginners!",
                                icon: "touch.svg",
                                styles: (moreInfo_module_default())
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        ref: ref,
                        className: "".concat((moreInfo_module_default()).linesWrapper, " ").concat(visibleClassName),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (moreInfo_module_default()).lines,
                            src: "/assets/landingpage/moreInfoLines.svg",
                            alt: "----------"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var moreInfo = (MoreInfo);

// EXTERNAL MODULE: ./components/landingPage/openSource.module.scss
var openSource_module = __webpack_require__(89171);
var openSource_module_default = /*#__PURE__*/__webpack_require__.n(openSource_module);
;// CONCATENATED MODULE: ./components/landingPage/openSource.tsx





var OpenSource = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    var handleButtonClick = function(url) {
        if (true) {
            window.open(url, "_blank");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: "".concat((openSource_module_default()).openSource, " ").concat(className),
        "data-cy": "openSource",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (openSource_module_default()).preTitle,
                children: "We are a community. We are a team."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (openSource_module_default()).title,
                children: "WE ARE OPEN SOURCE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (openSource_module_default()).description,
                children: "We need your help! Do you have feedback? Do you want to have a new game implemented? Do you want to improve your coding? We would love to learn from you!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (openSource_module_default()).buttonWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landingPage_button, {
                        color: "primary",
                        "data-cy": "openSourceGithubButton",
                        onClick: function() {
                            return handleButtonClick("https://github.com/etournity/etournity");
                        },
                        children: "Join the Team"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landingPage_button, {
                        color: "plain",
                        "data-cy": "openSourceVideoButton",
                        onClick: function() {
                            return handleButtonClick("https://www.youtube.com/watch?v=2D4ryfEDFvI");
                        },
                        children: "Watch Video"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var openSource = (OpenSource);

// EXTERNAL MODULE: ./components/landingPage/community.module.scss
var community_module = __webpack_require__(66019);
var community_module_default = /*#__PURE__*/__webpack_require__.n(community_module);
;// CONCATENATED MODULE: ./components/landingPage/community.tsx





var Community = function() {
    var videoId = "1IWWIdZZY6YRTmQOfL89Y3NEQufz1eQbh";
    var handleButtonClick = function(url) {
        if (true) {
            window.open(url, "_blank");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (community_module_default()).community,
        "data-cy": "community",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (community_module_default()).videoWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        muted: true,
                        autoPlay: true,
                        loop: true,
                        className: (community_module_default()).video,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            type: "video/mp4",
                            src: "https://drive.google.com/uc?export=download&id=".concat(videoId)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: (community_module_default()).videoOverlay
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (community_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (community_module_default()).title,
                        children: "JOIN THE COMMUNITY"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (community_module_default()).description,
                        children: "Interested in upcoming features? Want to stay up-to-date with our development? We would love to get to know you!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (community_module_default()).buttonWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(landingPage_button, {
                                color: "black",
                                className: (community_module_default()).button,
                                "data-cy": "communityDiscordButton",
                                onClick: function() {
                                    return handleButtonClick("https://discord.com/invite/ysm29w7Yxn");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/landingpage/discord.svg",
                                        alt: "Disc"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Join Discord"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(landingPage_button, {
                                color: "black",
                                className: (community_module_default()).button,
                                "data-cy": "communityTwitchButton",
                                onClick: function() {
                                    return handleButtonClick("https://www.twitch.tv/etournity");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/landingpage/twitch.svg",
                                        alt: "Twitch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Join Twitch"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var community = (Community);

// EXTERNAL MODULE: ./components/landingPage/tetris.module.scss
var tetris_module = __webpack_require__(54492);
var tetris_module_default = /*#__PURE__*/__webpack_require__.n(tetris_module);
;// CONCATENATED MODULE: ./components/landingPage/tetris.tsx






var Tetris = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: (tetris_module_default()).tetris,
        "data-cy": "tetris",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (tetris_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (tetris_module_default()).title,
                        children: " JUMP RIGHT INTO IT."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (tetris_module_default()).buttonWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(landingPage_button, {
                                color: "primary",
                                "data-cy": "tetrisCreateButton",
                                onClick: function() {
                                    return router.push("/tournament/new");
                                },
                                children: "Create Tournament"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(landingPage_button, {
                                color: "plain",
                                "data-cy": "tetrisJoinButton",
                                onClick: function() {
                                    return router.push("/tournaments");
                                },
                                children: "Join Tournament"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (tetris_module_default()).tetrisTiles,
                src: "/assets/landingpage/tetris1.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (tetris_module_default()).tetrisTiles,
                src: "/assets/landingpage/tetris2.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (tetris_module_default()).tetrisTiles,
                src: "/assets/landingpage/tetris3.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (tetris_module_default()).tetrisTiles,
                src: "/assets/landingpage/tetris4.svg"
            })
        ]
    });
};
/* harmony default export */ var tetris = (Tetris);

;// CONCATENATED MODULE: ./components/landingPage/index.tsx








;// CONCATENATED MODULE: ./pages/index.tsx





var Spacer = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: "".concat((landingpage_module_default()).spacer, " ").concat(className)
    });
};
var LandingPage = function() {
    (0,react.useEffect)(function() {
        if (true) window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: "".concat((landingpage_module_default()).landingPage),
        "data-cy": "landingpage",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(features, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(findLobby, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(moreInfo, {
                className: (landingpage_module_default()).sectionDark
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer, {
                className: (landingpage_module_default()).sectionDark
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(openSource, {
                className: (landingpage_module_default()).sectionDark
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(community, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tetris, {})
        ]
    });
};
/* harmony default export */ var pages = (LandingPage);


/***/ }),

/***/ 72540:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"button_idTarget__FLOgC","fabulousText":"button_fabulousText__xHoLf","rainbow":"button_rainbow__eHDkN","errorText":"button_errorText__s9qVk","button":"button_button__hn1tk","colorprimary":"button_colorprimary__WL86B","colorplain":"button_colorplain__N0HcR","colorblack":"button_colorblack__p7PsO"};

/***/ }),

/***/ 66019:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"community_idTarget__dFPpy","fabulousText":"community_fabulousText__1up6i","rainbow":"community_rainbow__u7XDb","errorText":"community_errorText__6_AFu","community":"community_community__s3xve","video":"community_video__FHLoe","videoWrapper":"community_videoWrapper__BJTIt","videoOverlay":"community_videoOverlay__cX86N","content":"community_content__L4ev_","title":"community_title__F6UFl","description":"community_description__mU_b4","button":"community_button__iM59d","buttonWrapper":"community_buttonWrapper__o71W7"};

/***/ }),

/***/ 2341:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"features_idTarget__I5PNY","fabulousText":"features_fabulousText__1wea5","rainbow":"features_rainbow__qWiwZ","errorText":"features_errorText__Zlm9V","features":"features_features__l4IlE","bottom":"features_bottom__UNfzv","visible":"features_visible__Yhj1G","moveIn":"features_moveIn__5xnYC","card":"features_card__hG0Ax","cardText":"features_cardText__EGY_y","cardTitle":"features_cardTitle__Y_qVh","cardDescription":"features_cardDescription__g8kuI","cardIcon":"features_cardIcon__T5L_7"};

/***/ }),

/***/ 9582:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"findLobby_idTarget__CJgc3","fabulousText":"findLobby_fabulousText__d6EUu","rainbow":"findLobby_rainbow__WBo2q","errorText":"findLobby_errorText__RkK6m","findLobby":"findLobby_findLobby__eftnv","SearchWrapper":"findLobby_SearchWrapper__OqCNR","bottom":"findLobby_bottom__QvlAj","image":"findLobby_image__BAEqP","CardWrapper":"findLobby_CardWrapper__f2U_3","SearchLg":"findLobby_SearchLg__IS8hQ","SearchSm":"findLobby_SearchSm__Bo1qh","Filters":"findLobby_Filters__evqwF","visible":"findLobby_visible__w47EV","moveFiltersIn":"findLobby_moveFiltersIn__uT1VT","moveCardsIn":"findLobby_moveCardsIn__R1Oyw"};

/***/ }),

/***/ 37762:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"header_idTarget__Y1Z2T","fabulousText":"header_fabulousText__mnehI","rainbow":"header_rainbow__61AwW","errorText":"header_errorText__r17b4","header":"header_header__W6GRG","video":"header_video__j5FcV","videoWrapper":"header_videoWrapper__JwTuZ","content":"header_content__aGL_H","title":"header_title__9f4Qo","titleHighlight":"header_titleHighlight__y3vuP","buttonWrapper":"header_buttonWrapper__oUhN6","banner":"header_banner__bjGvc","bannerTitle":"header_bannerTitle__u8SwO","bannerDescription":"header_bannerDescription__H24ts"};

/***/ }),

/***/ 91857:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"moreInfo_idTarget__epthn","fabulousText":"moreInfo_fabulousText__tjZ_X","rainbow":"moreInfo_rainbow__8ueAB","errorText":"moreInfo_errorText__oMT9f","moreInfo":"moreInfo_moreInfo__AaH3i","titleWrapper":"moreInfo_titleWrapper__G59Ka","content":"moreInfo_content__3VLJ3","card":"moreInfo_card__TQotA","cardWrapper":"moreInfo_cardWrapper__wV0re","cardIcon":"moreInfo_cardIcon____SM3","cardTitle":"moreInfo_cardTitle__heHAp","cardDescription":"moreInfo_cardDescription__l2V_x","lines":"moreInfo_lines__HQX7S","linesWrapper":"moreInfo_linesWrapper__WR38A","visible":"moreInfo_visible__2a6FD","fadeIn":"moreInfo_fadeIn__IqA5t"};

/***/ }),

/***/ 89171:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"openSource_idTarget__G_5ho","fabulousText":"openSource_fabulousText__fUdk2","rainbow":"openSource_rainbow__THMH9","errorText":"openSource_errorText__VupWG","openSource":"openSource_openSource__GS8VS","preTitle":"openSource_preTitle__cnmeY","title":"openSource_title__wPfLB","description":"openSource_description__vaFqU","buttonWrapper":"openSource_buttonWrapper__I7ZXa"};

/***/ }),

/***/ 19297:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"sectionTitle_idTarget__Tvmut","fabulousText":"sectionTitle_fabulousText__GVDlX","rainbow":"sectionTitle_rainbow__H3g5S","errorText":"sectionTitle_errorText__52FDr","container":"sectionTitle_container__RRKZ1","title":"sectionTitle_title__jFQ7L","visible":"sectionTitle_visible__h8GxO","fadeIn":"sectionTitle_fadeIn__jiVGa","description":"sectionTitle_description__rfYeC"};

/***/ }),

/***/ 54492:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"tetris_idTarget__rl1oD","fabulousText":"tetris_fabulousText__kiQHv","rainbow":"tetris_rainbow__qhN9e","errorText":"tetris_errorText__FahhE","tetris":"tetris_tetris__vs998","content":"tetris_content__dwJEB","title":"tetris_title__aVwTH","buttonWrapper":"tetris_buttonWrapper___av2k","tetrisTiles":"tetris_tetrisTiles__iYfoF"};

/***/ }),

/***/ 87781:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"landingpage_idTarget__domzG","fabulousText":"landingpage_fabulousText__kapLR","rainbow":"landingpage_rainbow__VPYez","errorText":"landingpage_errorText__7ICp3","landingPage":"landingpage_landingPage___xCz_","sectionDark":"landingpage_sectionDark__cfqA_","spacer":"landingpage_spacer___Dr44"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);